export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative flex min-h-[92vh] items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20Japanese%20manga%20ink%20illustration%20of%20a%20vast%20cosmic%20void%20with%20swirling%20dark%20ink%20nebula%2C%20drifting%20glowing%20crimson%20and%20amber%20manga%20speed%20lines%20and%20stars%2C%20dramatic%20deep%20charcoal%20background%20with%20warm%20red-orange%20highlights%2C%20high%20contrast%20artistic%20editorial%20comic%20artwork%2C%20cinematic%20composition&width=1600&height=900&seq=hero-void-2026&orientation=landscape"
        alt="虚空漫画网 官方入口 首屏插画"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/85 via-background-950/55 to-background-950/90" />

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-300 md:text-sm">
          <i className="ri-focus-3-line" />
          官网入口 · 首页地址 · 打不开的解决办法
        </span>

        <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl md:leading-tight">
          虚空漫画网
        </h1>
        <p className="mt-4 font-heading text-xl text-accent-300 md:text-3xl">
          海量连载 · 每日更新 · 随时开读
        </p>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          这里汇总了虚空漫画网最新可用的官方入口、首页地址，以及页面打不开时的备用通道与解决建议。
          收藏本页，随时快速进入虚空漫画网开始阅读，再也不用担心收藏的链接失效。
        </p>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
          <button
            type="button"
            onClick={() => scrollTo("entrance")}
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-7 py-3.5 text-base font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            立即进入阅读
            <i className="ri-arrow-right-up-line" />
          </button>
          <button
            type="button"
            onClick={() => scrollTo("guide")}
            className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/30 bg-background-50/5 px-7 py-3.5 text-base font-medium text-background-50 whitespace-nowrap backdrop-blur transition-colors hover:bg-background-50/15"
          >
            <i className="ri-tools-line" />
            打不开？看这里
          </button>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-background-100/80 md:text-sm">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-check-line text-secondary-400" />
            无需下载，浏览器即开
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-check-line text-secondary-400" />
            多入口保障访问
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-check-line text-secondary-400" />
            书架追更全免费
          </span>
        </div>
      </div>

      <button
        type="button"
        aria-label="向下滚动"
        onClick={() => scrollTo("entrance")}
        className="absolute bottom-6 left-1/2 z-10 hidden -translate-x-1/2 flex h-10 w-10 items-center justify-center rounded-full border border-background-50/25 text-background-50/80 transition-colors hover:bg-background-50/10 md:flex"
      >
        <i className="ri-arrow-down-line animate-bounce" />
      </button>
    </section>
  );
}